var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookShop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F95428"
    },
    d: "M461.492,14.862V497.14c0,8.207-6.653,14.862-14.862,14.862H96.17 c-8.207,0-14.862-6.653-14.862-14.862v-18.787l26.058,2.137c0.472,0.042,0.944,0.056,1.401,0.056c9.269,0,16.942-7.52,16.942-16.956 c0-8.839-6.785-16.179-15.582-16.9l-28.819-2.373v-34.73l26.058,2.137c0.472,0.042,0.944,0.056,1.401,0.056 c9.269,0,16.942-7.52,16.942-16.956c0-8.825-6.785-16.179-15.582-16.9l-28.819-2.373v-34.73l26.058,2.137 c0.472,0.042,0.957,0.055,1.429,0.055c9.255,0,16.914-7.52,16.914-16.956c0-8.825-6.785-16.179-15.582-16.9l-28.819-2.373v-34.716 l26.058,2.137c0.472,0.042,0.944,0.056,1.401,0.056c9.269,0,16.942-7.52,16.942-16.97c0-8.825-6.785-16.179-15.582-16.9 l-28.819-2.359v-34.73l26.058,2.137c0.472,0.042,0.944,0.055,1.401,0.055c9.269,0,16.942-7.52,16.942-16.956 c0-8.839-6.785-16.179-15.582-16.9l-28.819-2.373v-34.73l26.058,2.137c0.472,0.042,0.944,0.055,1.401,0.055 c9.269,0,16.942-7.52,16.942-16.956c0-8.825-6.785-16.179-15.582-16.9l-28.819-2.373v-34.73l26.058,2.137 c0.472,0.042,0.957,0.056,1.429,0.056c9.255,0,16.914-7.52,16.914-16.956c0-8.825-6.785-16.179-15.582-16.9l-28.819-2.373V14.862 C81.308,6.653,87.963,0,96.17,0h350.462C454.839,0,461.492,6.653,461.492,14.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E54728"
    },
    d: "M126.403,512H96.17c-8.207,0-14.862-6.653-14.862-14.862V14.862C81.308,6.653,87.963,0,96.17,0 h30.233V512z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3B3"
    },
    d: "M102.912,22.116c6.675,0.548,11.825,6.129,11.825,12.825c0,7.16-5.812,12.867-12.835,12.867 c-0.358,0-0.727-0.011-1.085-0.042l-19.774-1.622l-18.721-1.526c-6.675-0.548-11.813-6.129-11.813-12.825 c0-7.171,5.822-12.878,12.857-12.878c0.347,0,0.705,0.011,1.063,0.042l16.616,1.358L102.912,22.116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3B3"
    },
    d: "M102.912,77.638c6.675,0.548,11.825,6.129,11.825,12.825c0,7.16-5.822,12.867-12.857,12.867 c-0.347,0-0.705-0.011-1.063-0.042l-19.774-1.622l-18.721-1.537c-6.675-0.548-11.813-6.118-11.813-12.825 c0-7.16,5.822-12.867,12.857-12.867c0.347,0,0.705,0.011,1.063,0.042l16.616,1.358L102.912,77.638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3B3"
    },
    d: "M102.912,133.16c6.675,0.548,11.825,6.118,11.825,12.825c0,7.16-5.822,12.867-12.857,12.867 c-0.347,0-0.705-0.011-1.063-0.042l-19.774-1.622l-18.721-1.537c-6.675-0.548-11.813-6.129-11.813-12.825 c0-7.16,5.822-12.867,12.857-12.867c0.347,0,0.705,0.011,1.063,0.042l16.616,1.358L102.912,133.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3B3"
    },
    d: "M81.043,212.712l-18.721-1.537c-6.675-0.548-11.813-6.129-11.813-12.825 c0-7.16,5.812-12.867,12.835-12.867c0.358,0,0.727,0.011,1.085,0.042l16.616,1.358l21.869,1.79 c6.675,0.548,11.825,6.129,11.825,12.825c0,7.171-5.822,12.878-12.857,12.878c-0.347,0-0.705-0.011-1.063-0.042L81.043,212.712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3B3"
    },
    d: "M102.912,244.206c6.675,0.548,11.825,6.129,11.825,12.825c0,7.16-5.812,12.867-12.835,12.867 c-0.358,0-0.727-0.011-1.085-0.042l-19.774-1.622l-18.721-1.526c-6.675-0.548-11.813-6.129-11.813-12.825 c0-7.171,5.822-12.878,12.857-12.878c0.347,0,0.705,0.011,1.063,0.042l16.616,1.358L102.912,244.206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3B3"
    },
    d: "M102.912,299.73c6.675,0.548,11.825,6.129,11.825,12.825c0,7.16-5.822,12.867-12.857,12.867 c-0.347,0-0.705-0.011-1.063-0.042l-19.774-1.622l-18.721-1.537c-6.675-0.548-11.813-6.118-11.813-12.825 c0-7.16,5.822-12.867,12.857-12.867c0.347,0,0.705,0.011,1.063,0.042l16.616,1.358L102.912,299.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3B3"
    },
    d: "M102.912,355.252c6.675,0.548,11.825,6.118,11.825,12.825c0,7.16-5.822,12.867-12.857,12.867 c-0.347,0-0.705-0.011-1.063-0.042l-19.774-1.622l-18.721-1.537c-6.675-0.548-11.813-6.129-11.813-12.825 c0-7.16,5.822-12.867,12.857-12.867c0.347,0,0.705,0.011,1.063,0.042l16.616,1.358L102.912,355.252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3B3"
    },
    d: "M102.912,410.774c6.675,0.548,11.825,6.129,11.825,12.825c0,7.16-5.812,12.867-12.835,12.867 c-0.358,0-0.727-0.011-1.085-0.042l-19.774-1.622l-18.721-1.526c-6.675-0.548-11.813-6.129-11.813-12.825 c0-7.171,5.822-12.878,12.857-12.878c0.347,0,0.705,0.011,1.063,0.042l16.616,1.358L102.912,410.774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B3B3"
    },
    d: "M102.912,466.297c6.675,0.548,11.825,6.129,11.825,12.825c0,7.16-5.822,12.867-12.857,12.867 c-0.347,0-0.705-0.011-1.063-0.042l-19.774-1.622l-18.721-1.537c-6.675-0.548-11.813-6.118-11.813-12.825 c0-7.16,5.822-12.867,12.857-12.867c0.347,0,0.705,0.011,1.063,0.042l16.616,1.358L102.912,466.297z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 197.862,
    y: 177.604,
    style: {
      fill: "#666666"
    },
    width: 185.93,
    height: 20.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.862,
    y: 222.935,
    style: {
      fill: "#666666"
    },
    width: 185.93,
    height: 20.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.862,
    y: 268.252,
    style: {
      fill: "#666666"
    },
    width: 185.93,
    height: 20.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.862,
    y: 313.583,
    style: {
      fill: "#666666"
    },
    width: 185.93,
    height: 20.813
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookShop);
export default __webpack_public_path__ + "static/media/bookShop.eadd36d9e63179d907a0d8913aa392f4.svg";
export { ForwardRef as ReactComponent };